const axios = require('axios');
import EventBus from '../api/event-bus.js';
import {errorHandler} from "./common";

export function getInvoiceByRequest(id, type) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/request/invoice?id=' + id + '&type=' + type;
    axios.get(url,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function getInvoice(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/invoice?id=' + id;
    axios.get(url,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}

export function deleteInvoice(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/invoice?id=' + id;
    axios.delete(url,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function updateInvoice(invoice) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    axios.post(process.env.ROOT_API + 'admin/invoice', JSON.stringify(invoice),  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}

export function deleteInvoiceItem(id) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/invoice/item?id=' + id;
    axios.delete(url,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}

export function getInvoiceQuery(query) {
  return new Promise(function(resolve, reject) {
    EventBus.$emit("showLoading", true);
    let url = process.env.ROOT_API + 'admin/invoices?type=invoice,credit&'+query;
    axios.get(url,  {
      headers: {
        "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN")
      }
    }).then(function(response) {
      EventBus.$emit("showLoading", false);
      let data = response.data;
      resolve(data);
    }).catch(function(err) {
      EventBus.$emit("showLoading", false);
      errorHandler(err);
      reject(err);
    })
  })
}
export function getStatementPDF(statement) {
  let axiosConfig = {
    method: 'post',
    data:JSON.stringify(statement),
    url: process.env.ROOT_API + 'admin/statement',
    headers: {
      "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
      "Content-Type": "application/json"
    }
  };
  EventBus.$emit("showLoading", true);
  return new Promise(function(resolve, reject) {
    axios( axiosConfig).then(function(response) {
      EventBus.$emit("showLoading", false);
      resolve(response.data);
    }).catch(function(error) {
      EventBus.$emit("showLoading", false);
      errorHandler(error);
      reject(error)
    });
  })
}
export function getInvoicePDF(id) {
  let axiosConfig = {
    method: 'get',
    url: process.env.ROOT_API + 'admin/invoice/pdf?id='+id,
    headers: {
      "X-AUTH-TOKEN": localStorage.getItem("JSTOKEN"),
      "Content-Type": "application/json"
    }
  };
  EventBus.$emit("showLoading", true);
  return new Promise(function(resolve, reject) {
    axios( axiosConfig).then(function(response) {
      EventBus.$emit("showLoading", false);
      resolve(response.data);
    }).catch(function(error) {
      EventBus.$emit("showLoading", false);
      errorHandler(error);
      reject(error)
    });
  })
}

export function createNewInvoiceItem(invoiceId, requestId,) {
  let item = {
    id:0,
    title:'',
    invoiceId:invoiceId,
    requestId:requestId,
    currency:'GBP',
    vatRate:0,
    vatRateFloat:0.0,
    amount:0,
    amountFloat:0.0,
    vat:0,
    vatFloat:0.0,
    total:0,
    totalFloat:0.0,
    memo:'',

  }
  return item;
}
export function createNewInvoice(requestId, type) {
  let item = {
    id:0,
    requestId: requestId,
    customerId:0,
    type: type,
    invoiceToEmail:'',
    invoiceToTel:'',
    invoiceTo:'',
    invoiceAddress:'',
    invoiceNumber:'',
    quotationNumber:'',
    shippingMode:'',
    invoiceDate:'',
    dueDate:'',
    description:'',
    expatriatesName:'',
    Shipper:'',
    blNo:'',
    packingDate:'',
    pol:'',
    pod:'',
    vessel:'',
    deliveryDate:'',
    volume:'',
    deliveryPoint:'',
    consignee:'',
    etd:'',
    eta:'',
    containerSize:'',
    containerNumber:'',
    cbm:0,
    cbmFloat:0.0,
    kg:0,
    qty:0,
    residenceAddress:'',
    remarks:'',
    list:[],
    vat:0,
    amount:0,
    total:0,
    vatFloat:0,
    amountFloat:0,
    totalFloat:0,
    edit:false,
    currency:'GBP',
    url:'',
  }
  return item;
}



// WEBPACK FOOTER //
// ./src/api/invoices.js